import {useQueryClient} from "@tanstack/react-query";
import {Button, Paper, TextInput} from "@mantine/core";
import {useCallback, useContext, useState} from "react";
import {Row, Col} from "../../components/Flex/Flex";
import MessageContext from "../../context/MessageContext";
import api from "../../utils/api";


export default function RedeemVoucher() {
    const [voucher, setVoucher] = useState('');
    const [verifying, setVerifying] = useState(false);
    const queryClient = useQueryClient();
    const {success, error, setLoaderMessage} = useContext(MessageContext);


    const redeem = useCallback(() => {
        setLoaderMessage('Redeeming voucher...');
        setVerifying(true);
        api.get(`/subscribe/redeem/${voucher}`).then(res => {
            setLoaderMessage('');
            if (res.data.success) {
                success('Voucher has been redeemed', 'Enjoy your subscription!');
                queryClient.invalidateQueries({queryKey: ['user']});
                setVoucher('');
            } else {
                error(res.data.error);
            }
        }).finally(() => setVerifying(false));
    }, [queryClient, success, error, voucher])

    return (
        <Paper shadow="xs" p="md" withBorder style={{marginTop: '1rem', marginLeft: '1rem', marginRight: '1rem'}}>
            <h2 style={{margin: 0, marginBottom: '0.25rem'}}>Redeem a voucher</h2>
            <div style={{color: 'var(--mantine-color-dimmed)', fontSize: '1.125rem', lineHeight: 1.5, marginBottom: '0.5rem'}}>
                Do you have a voucher? Paste the full string in the input below to redeem it.
            </div>
            <Row>
                <Col>
                    <TextInput value={voucher} onChange={e => setVoucher(e.target.value)} placeholder="Voucher code" maxLength={32} style={{width: '20em'}}/>
                </Col>
                <Col>
                    <Button onClick={redeem} loading={verifying} disabled={!voucher && !verifying}>Redeem</Button>
                </Col>
            </Row>


        </Paper>
    )
}
